/**
 * withPoinstHistory
 * HOC for wrapping the provided component with StoredValueTransactionsProvider
 */

import React from 'react'

import StoredValueTransactionsProvider from './stored-value-transactions-provider'

export default function withStoredValueTransactions (WrappedComponent) {
  return function StoredValueTransactionsProviderHOC(props) {
    return (
      <StoredValueTransactionsProvider>
        <WrappedComponent {...props} />
      </StoredValueTransactionsProvider>
    )
  }
}
